import type { TFunction } from 'i18next';

import { DataTestIds } from '@repo/frontend-shared';
import { SDSButton } from '@repo/sds/SDSButton';
import { SDSDialog } from '@repo/sds/SDSDialog';
import { SDSFlexbox } from '@repo/sds/SDSFlexbox';
import { SDSText } from '@repo/sds/SDSText';

import { MfaSettingsPage } from './mfa-settings-page';

const MFA = DataTestIds.COMMON.SECURITY.MFA;

export function MfaDisableConfirmDialog({
  isMobile,
  onBackToMethods,
  onCancel,
  onConfirmDisableAll,
  t,
}: {
  isMobile: boolean;
  onBackToMethods: () => void;
  onCancel: () => void;
  onConfirmDisableAll: () => void;
  t: TFunction<'common'>;
}) {
  const title = t('security.mfa.disableConfirmTitle');
  const confirmLabel = t('security.mfa.disableConfirm');
  if (isMobile) {
    return (
      <MfaSettingsPage
        ariaLabel={title}
        backLabel={t('security.mfa.backToSecurity')}
        dataTestId={MFA.DISABLE_CONFIRM}
        onBack={onCancel}
      >
        <SDSText text={title} type="h5" />
        <SDSFlexbox direction="column" fullWidth gap="button-medium">
          <SDSButton
            dataTestId={MFA.CONFIRM}
            isFullWidth
            onClick={onConfirmDisableAll}
            status="alert"
            text={confirmLabel}
          />
          <SDSButton
            dataTestId={MFA.CANCEL}
            isFullWidth
            mode="outline"
            onClick={onBackToMethods}
            text={t('security.mfa.cancel')}
          />
        </SDSFlexbox>
      </MfaSettingsPage>
    );
  }
  return (
    <SDSDialog
      dataTestId={MFA.DISABLE_CONFIRM}
      isOpen
      onClose={onCancel}
      primaryAction={{
        dataTestId: MFA.CONFIRM,
        label: confirmLabel,
        onClick: onConfirmDisableAll,
        status: 'alert',
      }}
      secondaryAction={{ dataTestId: MFA.CANCEL, label: t('security.mfa.cancel'), onClick: onBackToMethods }}
      showCloseButton
      size="small"
      title={title}
    >
      {null}
    </SDSDialog>
  );
}
